import PropTypes from 'prop-types';
import cx from 'classnames';

import withTheme from 'core/hocs/withTheme';
import themePropTypes from 'core/utils/prop-types/theme';

import styles from './index.styl';


function Progressbar(props) {
  const {
    percent,
    type,
    active,
    theme: {
      controls: {
        gameCompare: {
          leaderBoard: {
            progressbar: progressbarAtoms,
          },
        },
      },
    },
  } = props;

  const percentValue = percent === 0 ? 0 : percent.toFixed(1);

  return (
    <div className={cx(
      styles.percentInfo,
      active && '_active',
      type && `_${type}`)}
    >
      <style jsx>{`
        .${styles.progressbar}
          background ${progressbarAtoms.background}
          height ${progressbarAtoms.height}
          ._active &
            background ${progressbarAtoms.activeBackground}

        .${styles.percent}
          font ${progressbarAtoms.font}

        .${styles.progress}
          height ${progressbarAtoms.progressHeight}
          background ${progressbarAtoms.finalProgress}
          ._default &
            background ${progressbarAtoms.defaultProgress}
      `}</style>
      <div className={styles.percent}>{percentValue}%</div>
      <div className={styles.progressbar}>
        <div
          className={styles.progress}
          style={{ width: `${percent || 0}%` }}
        />
      </div>
    </div>
  );
}

Progressbar.propTypes = {
  percent: PropTypes.number,
  type: PropTypes.string,
  active: PropTypes.bool,
  theme: themePropTypes(`
    {
      controls: {
        gameCompare: {
          leaderBoard: {
            progressbar: {
              background,
              defaultProgress,
              finalProgress,
              font,
              height,
              progressHeight,
            }
          }
        }
      }
    },
  `),
};

Progressbar.defaultProps = {
  percent: 0,
};

export default withTheme(Progressbar);

